import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { TAdPlacement } from '@x/common/ads/ad.config';
import { AdService } from '@x/common/ads/ad.service';
import { AdPictureComponent } from '@x/common/ads/components/ad-picture/ad-picture.component';
import { AdVideoComponent } from '@x/common/ads/components/ad-video/ad-video.component';
import { AdClickDirective } from '@x/common/ads/directive/ad-click.directive';
import { TShopAd } from '@x/ecommerce/shop-client';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'x-ad',
  standalone: true,
  imports: [AsyncPipe, AdPictureComponent, AdVideoComponent, AdClickDirective],
  templateUrl: './ad.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-ad' },
})
export class AdComponent implements OnInit, OnDestroy {
  private adToRelease: TShopAd | null;

  @Input({ required: true }) placement: TAdPlacement;

  @HostBinding('class')
  get hostClass() {
    return `${this.placement.toLowerCase()}`;
  }

  @Input() ad: TShopAd;
  @Input() taxonPath: string | undefined;
  @Input() taxonId?: number;

  ad$: Observable<TShopAd | null> = of(null);

  constructor(
    public elementRef: ElementRef,
    @Optional() private shopAdsService?: AdService,
  ) {}

  ngOnDestroy() {
    this.releaseAd();
  }

  releaseAd() {
    if (!this.shopAdsService || !this.adToRelease) return;
    this.shopAdsService.releaseAd(this.adToRelease);
  }

  ngOnInit(): void {
    if (!this.shopAdsService) return;

    this.ad$ = this.ad
      ? of(this.ad)
      : this.shopAdsService.ad$(this.placement, this.taxonPath).pipe(
          tap((ad) => {
            this.adToRelease = ad;
          }),
        );
  }

  getMediaType(ad: TShopAd): 'image' | 'video' {
    return ad.media[0].type === 'image' ? 'image' : 'video';
  }
}
